import {
    EmptyStructuredQuery,
    LogicalOperand,
    Operand,
    StructuredQuery,
    UrlQueryParams,
    UrlQueryParamsConverter
} from '@stylehaven/components';

import { DottedKey } from '../entities/metadata-field.entity';
import { RecordType } from '../entities/metadata.entity';

export function GetDossierTypeFacetUrlQueryParams(): UrlQueryParams {
    const structuredQuery: StructuredQuery = {
        ...EmptyStructuredQuery,
        Facets: [
            {
                LogicalOperand: LogicalOperand.And,
                DottedKey: DottedKey.RecordType,
                Buckets: [
                    {
                        Operand: Operand.Include,
                        Value: RecordType.Dossier
                    }
                ]
            }
        ]
    };
    return UrlQueryParamsConverter.generateQueryParams(structuredQuery);
}
